export default __webpack_public_path__ + "static/media/go-early-come-late.6eddd369.svg";